import React from 'react';
import {
  createBrowserRouter,
  RouterProvider,
  Route,
  createRoutesFromElements,
  Navigate,
  Outlet,
  ScrollRestoration,
  useLocation,
} from 'react-router-dom';
import { UserProvider, useUser } from 'contexts/UserContext';
import MealTracker from 'components/MealTracker';
import ProfilePage from 'pages/ProfilePage';
import LoadingScreen from 'components/LoadingScreen';
import AuthForm from 'components/AuthForm';
import { LoginRedirect } from 'components/LoginRedirect';
import { Toaster } from '@/components/ui/toaster';
import { CalorieEstimationExplanationPage } from './pages/CalorieEstimationExplanationPage';
import { useEffect } from 'react';
import { AnalyticsService } from 'services/firebaseService';

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, isLoading } = useUser();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

const AppContent = () => {
  const location = useLocation();

  useEffect(() => {
    AnalyticsService.logPageView(document.title, location.pathname);
  }, [location]);

  return (
    <>
      <ScrollRestoration />
      <Outlet />
    </>
  );
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<AppContent />}>
      <Route
        path="/login"
        element={
          <>
            <LoginRedirect />
            <AuthForm />
          </>
        }
      />
      <Route
        element={
          <ProtectedRoute>
            <Outlet />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<MealTracker />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route
          path="/calorie-estimation-explanation"
          element={<CalorieEstimationExplanationPage />}
        />
      </Route>
    </Route>,
  ),
);

function App() {
  return (
    <UserProvider>
      <RouterProvider router={router} />
      <Toaster />
    </UserProvider>
  );
}

export default App;
